import { __decorate } from "tslib";
import { Component, Emit, useModule, Vue, Watch } from "@/types";
import { Button, Input, Overlay, Modal, Calendar, Search, Radio, DropDown, SearchApi, } from "@/ui-kit";
import "./addAbsences.scss";
import { formObjectHelper } from "@/helpers/formDataHelper";
import { modifyingDateToIso } from "@/helpers";
let AddAbsences = class AddAbsences extends Vue {
    constructor() {
        super(...arguments);
        this.store = useModule(this.$store);
        this.modalData = {
            person: "",
            beginDate: "",
            endDate: "",
            comment: "",
            personIdentificationType: 1,
            absenceReasonType: 1,
        };
        this.absenceReasonTypes = [
            {
                id: 1,
                name: this.$l["vacation"],
            },
            {
                id: 2,
                name: this.$l["healthList"],
            },
            {
                id: 3,
                name: this.$l["businessTrip"],
            },
            {
                id: 4,
                name: this.$l["offWork"],
            },
        ];
        this.employeesData = [];
        this.isClearName = false;
        this.isClearNumber = false;
        this.name = "";
        this.staffNumber = "";
        this.errors = {
            person: "",
            beginDate: "",
            endDate: "",
            comment: "",
        };
    }
    created() {
        this.getReaderData();
    }
    async getReaderData() {
        try {
            await this.store.employees.get({
                skip: 0,
                filter: `organization eq ${this.store.orgList.currentOrg?.id}`,
            });
            this.employeesData = this.store.employees.list.map((item) => ({
                ...item,
                fio: `${item.surname} ${item.name} ${item.patronymic}`,
            }));
        }
        catch (e) {
            console.log(e, "readersData");
        }
    }
    mounted() {
        if (this.currDialog?.data) {
            const { name, data } = this.currDialog;
            if (name === "save") {
                this.modalData = {
                    ...formObjectHelper(this.modalData, data),
                };
                if (data.personIdentificationType === 1) {
                    this.isClearName = true;
                    this.name = `${data.surname} ${data.name} ${data.patronymic}`;
                    this.staffNumber = "";
                }
                if (data.personIdentificationType === 2) {
                    this.isClearNumber = true;
                    this.staffNumber = data.staffNumber ?? "";
                    this.name = "";
                }
            }
        }
    }
    isValid() {
        this.errors = {
            ...formObjectHelper(this.errors, this.store.validationField.valid),
        };
        if (this.modalData.personIdentificationType === 1) {
            this.errors.employees = this.store.validationField.valid["person"];
        }
        if (this.modalData.personIdentificationType === 2) {
            this.errors.staffNumber = this.store.validationField.valid["person"];
        }
    }
    get currDialog() {
        return this.store.dialog.curr;
    }
    handleRadioButton(id) {
        if (id === 1) {
            this.staffNumber = "";
        }
        if (id === 2) {
            this.name = "";
        }
        this.modalData.personIdentificationType = id;
        this.modalData.person = "";
        this.errors.employees = "";
        this.errors.staffNumber = "";
    }
    getId(arr) {
        this.modalData.person = arr.id;
    }
    getIdAndName(arr) {
        this.name = `${arr.surname} ${arr.name} ${arr.patronymic}`;
        this.modalData.person = arr.id;
    }
    resetId(val) {
        if (!val.length) {
            this.modalData.person = "";
        }
    }
    setAbsenceReasonType({ id, name }) {
        this.modalData.absenceReasonType = id;
    }
    async addAbsences() {
        this.modalData.beginDate = modifyingDateToIso(this.modalData.beginDate);
        this.modalData.endDate = modifyingDateToIso(this.modalData.endDate);
        const success = await this.store.absences.add({
            ...this.modalData,
        });
        if (success) {
            await this.store.notification.addNotification({
                type: "success",
                message: this.$l["success"],
            });
        }
        return success;
    }
    async editAbsences() {
        this.modalData.beginDate = modifyingDateToIso(this.modalData.beginDate);
        this.modalData.endDate = modifyingDateToIso(this.modalData.endDate);
        const success = await this.store.absences.edit({
            ...this.modalData,
        });
        if (success) {
            await this.store.notification.addNotification({
                type: "success",
                message: this.$l["success"],
            });
        }
        return success;
    }
    async successForm() {
        try {
            await (this.currDialog?.name === "save"
                ? this.editAbsences()
                : this.addAbsences());
        }
        catch (e) {
            console.log(e, "successForm");
        }
    }
};
__decorate([
    Watch("store.validationField.valid")
], AddAbsences.prototype, "isValid", null);
__decorate([
    Emit("success")
], AddAbsences.prototype, "addAbsences", null);
__decorate([
    Emit("success")
], AddAbsences.prototype, "editAbsences", null);
AddAbsences = __decorate([
    Component({
        components: {
            SearchApi,
            DropDown,
            Input,
            Overlay,
            Button,
            Modal,
            Calendar,
            Search,
            Radio,
        },
    })
], AddAbsences);
export default AddAbsences;
